import { StyleSheet, View, type DimensionValue } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type FeaturePageSectionCardProps = {
  title: string;
  description: string;
  statusLabel: string;
  progressPercent: number;
  nextStepLabel: string;
};

export function FeaturePageSectionCard({
  title,
  description,
  statusLabel,
  progressPercent,
  nextStepLabel,
}: FeaturePageSectionCardProps) {
  const progressWidth: DimensionValue = `${progressPercent}%`;

  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <AppText variant="subtitle" weight="bold">
          {title}
        </AppText>
        <View style={styles.badge}>
          <AppText variant="caption" weight="semibold" tone="primary">
            {statusLabel}
          </AppText>
        </View>
      </View>
      <AppText variant="body" tone="muted">
        {description}
      </AppText>
      <View style={styles.progressTrack}>
        <View style={[styles.progressFill, { width: progressWidth }]} />
      </View>
      <AppText variant="caption" tone="subtle">
        下一步：{nextStepLabel}
      </AppText>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: tokens.spacing.md,
  },
  badge: {
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.surfaceMuted,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.xs,
  },
  progressTrack: {
    height: tokens.layout.progressHeight,
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.surfaceMuted,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: tokens.radius.full,
    backgroundColor: tokens.colors.accent,
  },
});
